// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3ZD7p","header":"PatientBlock_header__3uE4y","label":"PatientBlock_label__26tvn","option":"PatientBlock_option__1tVdr"};